export { default } from './FeatureEdInfoIcon';
